import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
declare var $: any;

@Injectable({
  providedIn: 'root'
})
export class UpdateActionService {


  constructor() {

  }


  modeldata: string;
  modal = new Subject();

  open() {
    $('#myModal2').modal('show')
    this.modal.next(true);
  }
  close() {
    $('#myModal2').modal('hide')
    this.modal.next(false);
    localStorage.removeItem('timeLine');

  }
  closeModal() {
    this.close();
  }
}
